/**
 * Nombre d'articles dans le panier WooCommerce (cookie cross-domain).
 * Fonctionne lorsque le configurateur est servi sous le même domaine que WooCommerce.
 */
export function getWooCommerceCartItems() {
  const cookies = document.cookie.split("; ");
  const cartCookie = cookies.find((cookie) =>
    cookie.startsWith("woocommerce_items_in_cart="),
  );

  if (cartCookie) {
    const itemsInCart = parseInt(cartCookie.split("=")[1], 10);
    return Number.isNaN(itemsInCart) ? 0 : itemsInCart;
  }

  return 0;
}

function getCartCountFromFragments() {
  const fragmentsKeys = Object.keys(sessionStorage).filter((key) =>
    key.startsWith("wc_fragments_"),
  );

  if (fragmentsKeys.length === 0) return null;

  const value = sessionStorage.getItem(fragmentsKeys[0]);
  if (!value) return null;

  try {
    const parsed = JSON.parse(value);
    const html =
      parsed[".elementor-menu-cart__toggle_button span.elementor-button-icon-qty"];
    const match = html?.match(/data-counter="?(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  } catch {
    return null;
  }
}

/** Compteur panier : fragments Elementor si dispo, sinon cookie WooCommerce. */
export function getCartItemCount() {
  const fromFragments = getCartCountFromFragments();
  if (fromFragments !== null) return fromFragments;
  return getWooCommerceCartItems();
}
